import React from 'react';
import { Link } from 'react-router-dom';

const SamudyogaFooter = () => (
    <footer className="samudyoga-footer">
        <div className="inner">
            <div>
                <span className="brand-tag">Samudyoga</span> — a Dharma Poshanam initiative.
                <div className="note">
                    Connecting Dharmikas to employ professionals and engage service providers
                    — on-event, short-term to long-term.
                </div>
                <div className="note">
                    Connect · Engage · Empower · स्वधर्म
                </div>
            </div>
            <div>
                <Link to="/">Home</Link>
                <Link to="/job-listings">Opportunities</Link>
                <Link to="/apps">Swadharma Apps</Link>
                <Link to="/contact-us">Contact</Link>
                <a href="#" rel="noreferrer">Privacy</a>
                <a href="#" rel="noreferrer">Terms</a>
            </div>
        </div>
        <div className="inner" style={{ marginTop: 24, paddingTop: 16, borderTop: '1px solid rgba(255,255,255,0.1)' }}>
            <div className="note" style={{ flex: '1 1 100%' }}>
                Payments route through Dharma Poshanam:{' '}
                <a href="https://dharmaposhanam.in/support" rel="noreferrer">dharmaposhanam.in/support</a>{' '}
                (USA · Stripe &amp; PayPal) ·{' '}
                <a href="https://dharmaposhanam.in/donate" rel="noreferrer">dharmaposhanam.in/donate</a>{' '}
                (India · Razorpay). The platform retains 10% on paid services for upkeep.
                Refunds are not issued — all retained funds accrue to the charity corpus.
            </div>
        </div>
    </footer>
);

export default SamudyogaFooter;
